import React from 'react';
import { Star, Shield, Lock, CreditCard, Zap } from 'lucide-react';
import { Section, CountdownTimer, CTAButton } from './Shared';
export function MidCTA() {
  return <Section className="bg-brand-surfaceLight/30 rounded-3xl my-12" data-id="element-236">
      <div className="text-center mb-10" data-id="element-237">
        <h2 className="text-2xl md:text-3xl font-serif font-bold text-brand-gold mb-6" data-id="element-238">
          ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
        </h2>
        <CountdownTimer data-id="element-239" />
        <p className="mt-4 text-red-400 font-medium" data-id="element-240">
          ⚠️ Después sube $8.000 ARS. No vuelve.
        </p>
        <p className="mt-2 text-brand-gold/80 text-sm" data-id="element-241">
          🔴 Quedan pocos cupos al precio de lanzamiento
        </p>

        <div className="max-w-md mx-auto mt-4" data-id="element-242">
          <div className="w-full bg-white rounded-full h-2.5 border border-brand-pink/30 overflow-hidden shadow-inner" data-id="element-243">
            <div className="bg-brand-green h-2.5 rounded-full" style={{
            width: '68%'
          }} data-id="element-244"></div>
          </div>
          <p className="text-xs text-brand-text/60 mt-2" data-id="element-245">
            68% de cupos al precio de lanzamiento ya tomados
          </p>
        </div>
      </div>

      <div className="max-w-md mx-auto mb-12" data-id="element-246"></div>

      <h3 className="text-3xl font-serif font-bold text-center mb-10" data-id="element-247">
        ELEGÍ TU MEGAPACK
      </h3>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-248">
        {/* Basic Tier */}
        <div className="glass-panel rounded-3xl p-8 flex flex-col border-brand-pink/30 hover:border-brand-gold/30 transition-colors bg-white/60" data-id="element-249">
          <div className="mb-6" data-id="element-250">
            <h4 className="text-2xl font-serif font-bold mb-2 flex items-center" data-id="element-251">
              📘 MEGAPACK CÓDIGO DE ABUNDANCIA
            </h4>
            <p className="text-brand-gold font-medium" data-id="element-252">6 Tomos + 2 Bonus</p>
          </div>

          <div className="bg-brand-surfaceLight/50 p-4 rounded-xl mb-6 text-sm text-brand-text/80 border border-brand-pink/20" data-id="element-253">
            <span className="font-bold text-[#D4AF37]" data-id="element-254">Ideal para:</span> Quien
            quiere transformar su realidad financiera en 180 días
          </div>

          <div className="mb-8" data-id="element-255">
            <div className="text-brand-text/50 line-through text-xl mb-1" data-id="element-256">
              $47.000
            </div>
            <div className="text-5xl font-bold text-brand-text mb-2" data-id="element-257">
              $19.990{' '}
              <span className="text-xl text-brand-text/70 font-normal" data-id="element-258">
                ARS
              </span>
            </div>
          </div>

          <div className="mt-auto" data-id="element-259">
            <CTAButton fullWidth className="text-base py-4 bg-white text-brand-text border border-brand-gold/30 hover:bg-brand-surfaceLight/80" href="https://www.lumenakasha.com/cart/46699505975485:1" data-id="element-260">
              → QUIERO MI MEGAPACK AHORA
            </CTAButton>
          </div>
        </div>

        {/* Premium Tier */}
        <div className="glass-panel rounded-3xl p-8 flex flex-col border-brand-gold relative transform lg:-translate-y-4 shadow-[0_10px_40px_rgba(212,175,55,0.15)] bg-white/80" data-id="element-261">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-brand-gold text-white font-bold px-4 py-1 rounded-full text-sm flex items-center shadow-lg whitespace-nowrap" data-id="element-262">
            <Star className="w-4 h-4 mr-1 fill-current" data-id="element-263" /> MÁS POPULAR
          </div>

          <div className="mb-6 mt-2" data-id="element-264">
            <h4 className="text-2xl font-serif font-bold mb-2 flex items-center text-brand-text" data-id="element-265">
              🏆 MEGAPACK + INSTANTE ABUNDANTE
            </h4>
            <p className="text-brand-gold/80 font-medium" data-id="element-266">
              6 Tomos + 2 Bonus + Agenda de 90 días
            </p>
          </div>

          <div className="bg-brand-gold/10 p-4 rounded-xl mb-6 text-sm text-brand-text/90 border border-brand-gold/20" data-id="element-267">
            <span className="font-bold text-brand-gold" data-id="element-268">Ideal para:</span> Quien
            quiere resultados desde el primer día sin leer todo primero
          </div>

          <div className="mb-8" data-id="element-269">
            <div className="text-brand-text/50 line-through text-xl mb-1" data-id="element-270">
              $65.000
            </div>
            <div className="text-5xl font-bold text-brand-text mb-2" data-id="element-271">
              $27.990{' '}
              <span className="text-xl text-brand-text/70 font-normal" data-id="element-272">
                ARS
              </span>
            </div>
          </div>

          <div className="mt-auto" data-id="element-273">
            <CTAButton fullWidth className="text-lg py-5 animate-pulse-slow" href="https://www.lumenakasha.com/cart/46699573543101:1" data-id="element-274">
              → QUIERO EL MEGAPACK COMPLETO
            </CTAButton>
          </div>
        </div>
      </div>

      <div className="flex flex-wrap gap-6 mt-12 text-sm text-brand-muted flex-row items-start justify-center" data-id="element-275">
        <div className="flex items-center" data-id="element-276">
          <Lock className="w-4 h-4 mr-2" data-id="element-277" /> Pago 100% seguro
        </div>
        <div className="flex items-center" data-id="element-278">
          <Zap className="w-4 h-4 mr-2" data-id="element-279" /> Acceso en 5 minutos
        </div>
        <div className="flex items-center" data-id="element-280">
          <Shield className="w-4 h-4 mr-2" data-id="element-281" /> Garantía 7 días
        </div>
        <div className="flex items-center" data-id="element-282">
          <CreditCard className="w-4 h-4 mr-2" data-id="element-283" /> Mercado Pago · Tarjeta ·
          Transferencia
        </div>
      </div>
    </Section>;
}